/**
 * Inline MSW responses for the cancel-shipment dialog.
 * Spread into INLINE_RESPONSES in inlineResponses.tsx.
 */
export const CANCEL_SHIPMENT_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // Other pickups at the shipment's pickup address, around its pickup date, shown in the cancel
  // dialog. Three rows on purpose: the same-day same-carrier one (the risky case the feature
  // exists for), a same-day one with another carrier (context the operator still wants), and a
  // delayed pickup still showing yesterday's date (why the window reaches past the pickup date).
  "/apollo/shipments/related-pickups": [
    {
      shipmentId: "3f2a9c14-6b7d-4e8f-9a01-2c3d4e5f6a7b",
      carrierIdentifier: "estes",
      carrierPickupNumber: "PU9948213",
      billOfLadingNumber: "FS-2048817",
      businessName: "Hartzell Propeller, Inc",
      addressLines: "1234 Industrial Way, Unit 5",
      cityProvincePostalCode: "Langley BC V3A 4R2",
      pickupDate: "2026-08-13",
      state: "booking_confirmed",
      isSameCarrier: true,
      isSamePickupDate: true,
      isSameStreetAddress: true,
      mentionedInCancelEmail: true,
    },
    {
      shipmentId: "8c1b2d35-4e5f-6a7b-8c9d-0e1f2a3b4c5d",
      carrierIdentifier: "saia",
      carrierPickupNumber: "4471902",
      billOfLadingNumber: "FS-2048902",
      businessName: "Hartzell Propeller, Inc",
      addressLines: "1234 Industrial Way, Unit 5",
      cityProvincePostalCode: "Langley BC V3A 4R2",
      pickupDate: "2026-08-13",
      state: "booking_confirmed",
      isSameCarrier: false,
      isSamePickupDate: true,
      isSameStreetAddress: true,
      mentionedInCancelEmail: false,
    },
    {
      shipmentId: "5d7e8f90-1a2b-3c4d-5e6f-7a8b9c0d1e2f",
      carrierIdentifier: "estes",
      carrierPickupNumber: "PU9947001",
      billOfLadingNumber: "FS-2048640",
      businessName: "Hartzell Propeller, Inc",
      addressLines: "1234 Industrial Way, Unit 5",
      cityProvincePostalCode: "Langley BC V3A 4R2",
      pickupDate: "2026-08-12",
      state: "booking_confirmed",
      isSameCarrier: true,
      isSamePickupDate: false,
      isSameStreetAddress: true,
      mentionedInCancelEmail: false,
    },
    // Same postal code, same day, same carrier — but a different building. A postal code is not
    // an address, so this neighbour must never reach the email; naming it would tell the carrier
    // we have freight at "this same address" when we do not.
    {
      shipmentId: "9a0b1c2d-3e4f-5a6b-7c8d-9e0f1a2b3c4d",
      carrierIdentifier: "estes",
      carrierPickupNumber: "PU9949555",
      billOfLadingNumber: "FS-2049101",
      businessName: "Northline Fabrication Ltd",
      addressLines: "8870 Production Court",
      cityProvincePostalCode: "Langley BC V3A 4R2",
      pickupDate: "2026-08-13",
      state: "booking_confirmed",
      isSameCarrier: true,
      isSamePickupDate: true,
      isSameStreetAddress: false,
      mentionedInCancelEmail: false,
    },
  ],
  // The cancel-pickup email as the carrier would receive it, including the warning naming the
  // same-carrier pickup above so it does not get cancelled along with this one. The body arrives
  // already rendered to paragraphs.
  "/apollo/shipments/preview-cancel-pickup-email": {
    subject: "Cancel Pickup PU# PU9948100",
    body: '<p class="MsoNormal"><o:p>&nbsp;</o:p></p>\n<p class="MsoNormal"><strong>Re: PU#PU9948100 (from Hartzell Propeller, Inc, 1234 Industrial Way, Unit 5, Langley BC V3A 4R2)</strong><o:p></o:p></p>\n<p class="MsoNormal"><o:p>&nbsp;</o:p></p>\n<p class="MsoNormal">Please cancel this pickup.<o:p></o:p></p>\n<p class="MsoNormal"><o:p>&nbsp;</o:p></p>\n<p class="MsoNormal"><strong>IMPORTANT — please do not cancel our other pickup at this address.</strong><o:p></o:p></p>\n<p class="MsoNormal"><o:p>&nbsp;</o:p></p>\n<p class="MsoNormal">We have another shipment booked with you for collection from this same address on the same day, which we still need collected:<o:p></o:p></p>\n<p class="MsoNormal"><o:p>&nbsp;</o:p></p>\n<ul>\n<li>PU# PU9948213 — Hartzell Propeller, Inc</li>\n</ul>\n<p class="MsoNormal"><o:p>&nbsp;</o:p></p>\n<p class="MsoNormal">Please cancel only the pickup referenced above and leave this one in place.<o:p></o:p></p>',
  },
};
